module.exports = __webpack_public_path__ + "img/medal-bronze.f44a7ca4.png";